import { apiClient } from './index';

/**
 * GET /billing/usage — measured usage for the caller's tenant (tenant admin
 * or superadmin only; 403 otherwise). Mirrors billing.UsageResponse.
 * `*_mtd` values count from `period_start`. A null value means that meter is
 * not wired in this deployment: unknown, never zero. Plan limits are
 * returned separately by GET /billing. People include reserved invitations;
 * projects exclude archived projects.
 */
export interface BillingUsage {
  measured_at: string;
  period_start: string;
  users: number;
  projects: number;
  storage_bytes: number;
  ai_calls_mtd: number | null;
  ai_tokens_mtd: number | null;
  mcp_calls_mtd: number | null;
}

export async function getBillingUsage(): Promise<BillingUsage> {
  const { data } = await apiClient.get<BillingUsage>('/billing/usage');
  return data;
}
